<template>
  <div class="summary-wrapp">
    <div class="summary">
      <div class="summary-block" v-if="calculation.treatmentAbroad.isActive">
        <h3 class="title">
          Finansowanie leczenia za granicą
        </h3>
        <ul class="summary-block__list summary-list">
          <li class="summary-list__item">
            <span class="summary-list__label">
              MAX wartość świadczeń – 2 mln € / osobę
            </span>
          </li>
          <li class="summary-list__item">
            <span class="summary-list__label">
              Liczba osób dorosłych:
            </span>
            <span
              class="summary-list__value"
              v-if="calculation.treatmentAbroad.family.active"
            >
              {{ calculation.treatmentAbroad.family.adults }}
            </span>
            <span v-else>
              1
            </span>
          </li>
          <li
            class="summary-list__item"
            v-if="
              calculation.treatmentAbroad.family.children > 0 &&
                calculation.treatmentAbroad.family.active
            "
          >
            <span class="summary-list__label">
              Liczba dzieci:
            </span>
            <span class="summary-list__value">
              {{ calculation.treatmentAbroad.family.children }}
            </span>
          </li>
          <li class="summary-list__item">
            <span class="summary-list__label">
              Składka miesięczna:
            </span>
            <span class="summary-list__value">
              {{
                this.calculation.treatmentAbroad.monthlyContribution
                  | currency(2)
              }}
            </span>
          </li>
        </ul>
      </div>
      <div class="summary-block" v-if="calculation.moneySupport.isActive">
        <h3 class="title">Wsparcie finansowe w chorobie</h3>
        <ul class="summary-block__list summary-list">
          <li
            class="summary-list__item"
            v-if="calculation.moneySupport.isActive"
          >
            <span class="summary-list__label">
              Budżet na świadczenia medyczne i usługi:
            </span>
            <span class="summary-list__value">
              {{ calculation.moneySupport.budget | currency }}
            </span>
          </li>
          <li class="summary-list__item">
            <span class="summary-list__label">
              Miesięczne wsparcie w okresie leczenia [6mc]:
            </span>
            <span class="summary-list__value">
              {{ calculation.moneySupport.monthlySupport | currency }}
            </span>
          </li>
          <li class="summary-list__item">
            <span class="summary-list__label">
              Składka miesięczna:
            </span>
            <span class="summary-list__value">
              {{
                this.calculation.moneySupport.monthlyContribution | currency(2)
              }}
            </span>
          </li>
        </ul>
      </div>

      <div class="summary-block" v-if="calculation.lifeInsurance.isActive">
        <h3 class="title">Ubezpieczenie na życie</h3>
        <ul class="summary-block__list summary-list">
          <li class="summary-list__item">
            <span class="summary-list__label">
              Budżet na spłatę zobowiązań :
            </span>
            <span class="summary-list__value">
              {{ calculation.lifeInsurance.debt | currency }}
            </span>
          </li>
          <li class="summary-list__item">
            <span class="summary-list__label">
              Miesięczne wsparcie dla rodziny:
            </span>
            <span class="summary-list__value">
              {{ calculation.lifeInsurance.familySupport | currency }}
            </span>
          </li>
          <li class="summary-list__item">
            <span class="summary-list__label">
              Okres zabezpieczenia rodziny:
            </span>
            <span class="summary-list__value">
              {{ this.calculation.lifeInsurance.period | year }}
            </span>
          </li>
          <li
            class="summary-list__item"
            v-if="calculation.lifeInsurance.guarantee"
          >
            <span class="summary-list__label">
              Gwarancja stałej składki
            </span>
          </li>
          <li class="summary-list__item">
            <span class="summary-list__label">
              Składka miesięczna:
            </span>
            <span class="summary-list__value">
              {{
                this.calculation.lifeInsurance.monthlyContribution | currency(2)
              }}
            </span>
          </li>
        </ul>
      </div>
    </div>
    <div class="monthly-sum">
      <div class="monthly-sum__block">
        <span class="monthly-sum__label">
          Całkowita składka miesięczna:
        </span>
        <span class="monthly-sum__value">{{
          calculation.finalMonthlySum | currency(2)
        }}</span>
      </div>
    </div>
    <div class="disclaimer">
      <md-icon class="text-warning">warning</md-icon>
      <p>
        Powyższa wycena ma charakter informacyjny i nie stanowi oferty w
        rozumieniu art.66 Kodeksu Cywilnego. Decyzja o zawarciu poszczególnych
        umów ubezpieczenia i ostatecznej wysokości składki podjęta zostanie
        przez zakład ubezpieczeń po analizie złożonych oświadczeń dotyczących
        stanu zdrowia.
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SummaryData',
  data() {
    return {
      calculation: null,
    }
  },
  created() {
    this.setCalculationData()
  },
  computed: {},
  methods: {
    setCalculationData() {
      this.calculation = JSON.parse(localStorage.getItem('calculation'))
    },
  },
}
</script>

<style scoped lang="scss">
.summary {
  border: dashed #7d7d7d;
  border-width: 1px 1px 0;
  border-radius: 4px 4px 0 0;
  &-block {
    padding: 23px 45px 30px 20px;
    border-bottom: 1px dashed #7d7d7d;
    @media screen and (max-width: 576px) {
      padding: 23px 9px 30px 9px;
    }
    &:last-child {
      border: 0;
    }
    .title {
      font-size: 21px;
      font-weight: 700;
      @media screen and (max-width: 576px) {
        font-size: 19px;
      }
    }
  }
}
.summary-list {
  padding: 0 0 0 25px;
  margin: 0;
  @media screen and (max-width: 576px) {
    padding-left: 10px;
  }
  &__item {
    position: relative;
    color: #707070;
    margin-top: 18px;
    font-weight: 500;
    font-size: 1rem;
    list-style-type: none;
    display: flex;
    justify-content: space-between;
    @media screen and (max-width: 576px) {
      font-size: 15px;
    }
    &:first-child {
      margin-top: 13px;
    }
    &::before {
      position: absolute;
      content: '-';
      top: 0;
      margin-top: -1px;
      left: -8px;
    }
  }
}
.monthly-sum {
  padding: 19px 45px 17px 20px;
  border-radius: 0 0 4px 4px;
  color: #fff;
  background-color: #7d7d7d;
  font-size: 1.3rem;
  font-weight: 500;
  @media screen and (max-width: 576px) {
    font-size: 16px;
    padding: 19px 9px 17px 9px;
  }
  &__block {
    display: flex;
    justify-content: space-between;
  }
  &__label {
  }
}
.disclaimer {
  font-size: 11px;
  margin-top: 15px;
  line-height: 1.4em;
  display: flex;
  p {
    margin-left: 5px;
  }
}
</style>
